import hmd_softlock_logo from 'url:/assets/hmd_softlock_logo.svg'
import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import * as Yup from 'yup'
import { useApiVerifyCode } from '../../api/account/apiUsers'
import { Button } from '../../genericComponents/Button'
import { InputGreenNoDecoration } from '../../inputs/InputGreenNoDecoration'
import { redirectPages } from './LoginPage'
import { useNavigate } from 'react-router'
import { ApiError, LoginDto } from '../../generated'
import { INPUT_FORM_COMMON_SIZE } from '../../genericComponents/OverlayWrapper'
import { FlexContainer } from '../../genericComponents/layout/FlexContainer'

interface VerifyForm {
  code?: number
}

export function getRedirectUrl(redirectArg: string) {
  const redirect = redirectArg?.replaceAll('redirect:', '')
  return redirect.startsWith('/') ? redirect : `/${redirect}`
}

export const VerifyPage: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const { mutateAsync: verify } = useApiVerifyCode()

  const navigate = useNavigate()

  const validationSchema = Yup.object().shape({
    code: Yup.number().typeError('Code must be a valid number').required('Code is required'),
  })

  const handleSubmit = async (
    values: VerifyForm,
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    await verify(
      { code: values.code?.toString() ?? '' },
      {
        onError: ((errorData: { body: { apierror: ApiError } }) => {
          let msg = errorData.body.apierror.message
          if (msg == 'validation failed: Invalid OTP code') {
            msg = "The verification code you've entered is incorrect. Please try again."
          }
          values.code = undefined
          setErrorMessage(msg ?? 'Something went wrong please try again')
          setSubmitting(false)
        }) as (error: unknown) => void,
        onSuccess: (data: LoginDto) => {
          if (data.role == 'REGISTRATION_NEEDED') {
            void navigate('/ftu')
          } else if (data.role == 'TFA_REQUIRED') {
            void navigate('/verify')
          } else {
            if (data.role) {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              window.location.href = redirectPages[data.role] ?? ''
            }
          }
        },
      }
    )
  }

  const initialValues: VerifyForm = {
    code: undefined,
  }

  return (
    <div className="flex h-screen justify-center">
      <div className="bg-brandDark w-[40%] h-full bg-cover bg-login-art">
        <div className="w-full h-full bg-primaryAccentColor opacity-60"></div>
      </div>
      <div className="flex bg-white w-3/5 justify-center">
        <FlexContainer
          align="items-start"
          justify="justify-center"
          className={'flex-col ' + INPUT_FORM_COMMON_SIZE}
        >
          <img src={hmd_softlock_logo} alt="Logo" className="mb-6 w-52" />
          <p className="my-3 text-primaryFontColor text-sm ">
            Enter your 6-digit authentication code from the Google Authenticator app.
          </p>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
          >
            {() => (
              <Form className={'flex flex-col ' + INPUT_FORM_COMMON_SIZE}>
                <InputGreenNoDecoration
                  name="code"
                  placeholder="Google Authenticator Verification Code"
                  className="w-full"
                  autocompleteOff
                  autoFocus
                />

                {errorMessage && (
                  <div className="flex">
                    <span className="text-alertColor text-sm font-semibold italic">
                      {errorMessage}
                    </span>
                  </div>
                )}

                <Button
                  type="submit"
                  className="min-h-10 self-center max-w-64 w-full uppercase my-3"
                >
                  Continue
                </Button>
              </Form>
            )}
          </Formik>
        </FlexContainer>
      </div>
    </div>
  )
}
